import ReactDOM from "react-dom";

const Portal = ({ children, node }) => {
    return ReactDOM.createPortal(children, node);
};

export default Portal;
